module.exports = __webpack_public_path__ + "img/category-page.83c475d3.jpg";